import React from "react";
// Libraries
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import {store, persistor} from "./stores";
import { PersistGate } from "redux-persist/integration/react";
import { Provider } from "react-redux";

// Screens
import App from "./Containers/App/App";
// Themes
import "./index.css";

const app = (
  <BrowserRouter>
    <Provider {...{ store }}>
      <PersistGate loading={null} {...{ persistor }}>
        <App />
      </PersistGate>
    </Provider>
  </BrowserRouter>
);

ReactDOM.render(app, document.getElementById("root"));


// WEBPACK FOOTER //
// ./src/index.js